import React, { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import firebase from "firebase/app";
import { UserContext } from "../contexts/user";
import { useNavigate } from 'react-router-dom';

export default function CheckoutForm() {
  // const history = useHistory();
  const navigate = useNavigate();

  const { loadingAuthState } = useContext(UserContext);

  const cart = new URLSearchParams(useLocation().search).get("cart");
  const optionId = new URLSearchParams(useLocation().search).get("optionId");
  const serviceId = new URLSearchParams(useLocation().search).get("serviceId");
  const recurrence = new URLSearchParams(useLocation().search).get("recurrence");
  const paymentIntent = new URLSearchParams(useLocation().search).get("payment_intent");
  const offline = new URLSearchParams(useLocation().search).get("offline");
  const email = new URLSearchParams(useLocation().search).get("email");
  const uid = new URLSearchParams(useLocation().search).get("uid");
  const discountCodeToApply = new URLSearchParams(useLocation().search).get("discountCodeToApply");


  useEffect(() => {
    if (!paymentIntent || loadingAuthState) return;

    (async function () {
      // console.log("doing this nowww");
      const headers = { "Content-Type": "application/json" };

      let mongoUrl = new URL("https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/orders");
      // let mongoUrl = new URL("http://localhost:8087/services/orders");
      mongoUrl.searchParams.append("cart", cart);
      if (optionId) {
        mongoUrl.searchParams.append("optionId", optionId);
      }
      if (serviceId) {
        mongoUrl.searchParams.append("serviceId", serviceId);
      }
      if (recurrence) {
        mongoUrl.searchParams.append("recurrence", recurrence);
      }

      if (discountCodeToApply) {
        mongoUrl.searchParams.append("discountCodeToApply", discountCodeToApply);
      }

      if (offline === "true") {
        mongoUrl.searchParams.append("offline", offline);
        if (email) {
          mongoUrl.searchParams.append("email", email);
        }
        if (uid) {
          mongoUrl.searchParams.append("uid", uid);
        }
      } else {
        const { currentUser } = firebase.auth();
        if (!currentUser) {
          alert("You must be logged first to view this page!");
          return;
        }
        const token = await currentUser.getIdToken();
        headers["Authorization"] = `Bearer ${token}`;
      }


      try {
        const req = await fetch(mongoUrl?.toString(), {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            paymentIntent,
          }),
        });
        const response = await req.json();
        // console.log("yoo heree", response);
        if (response.ok === true && response.orderId) {
          navigate({ pathname: `/orders/${response?.orderId}` });
        } else {
          navigate("/my-courses");
        }
      } catch (e) {
        console.log("something went wrong!", e);
        navigate("/my-courses");
      }
    })();

    // const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
  }, [loadingAuthState]);

  return (
    <div className="loading-component">
      <lottie-player
        src="/loader_lottie.json"
        background="transparent"
        speed="1"
        style={{ width: '300px', height: '300px' }}
        loop
        autoplay>
      </lottie-player>
    </div>
  )


  // return null;
}
